export const MAX_INGREDIENTS = 10;
export const MIN_INGREDIENTS = 1;
export const FREE_INGREDIENTS = 3;

export const BASE_INGREDIENTS_CATEGORIES = {
  BASE_CHEESE: 'base_cheese',
  BASE_SAUCE: 'base_sauce',
  NOT_INGREDIENT: 'not_ingredient'
};

// eslint-disable-next-line id-length
export const BASE_INGREDIENTS_CATEGORIES_LIST = Object.values(BASE_INGREDIENTS_CATEGORIES);
